import { ReactComponent as Icon } from "../files/information-note.svg";

import ISVGIconProps from "../ISVGIconProps";

const DetailsIcon = ({
    fill,  
    style = {},
}: ISVGIconProps) => {   
    return (
        <div style={style}>
            <Icon
                fill={fill} 
                style={style}        
            />
        </div>
    );
};

export default DetailsIcon;
